import axiosInstance from './axiosInstance';
import { Conversation, ChatMessage, MessagesPage, UserSummary } from '../types/chat.types';

const BASE = '/Chat';

const chatService = {
  getConversations: (): Promise<Conversation[]> =>
    axiosInstance.get(`${BASE}/conversations`).then(r => r.data),

  getOrCreateDirect: (userId: number): Promise<Conversation> =>
    axiosInstance.post(`${BASE}/conversations/direct/${userId}`).then(r => r.data),

  createGroup: (name: string, memberUserIds: number[]): Promise<Conversation> =>
    axiosInstance.post(`${BASE}/conversations/group`, { name, memberUserIds }).then(r => r.data),

  getMessages: (conversationId: number, page = 1): Promise<MessagesPage> =>
    axiosInstance.get(`${BASE}/conversations/${conversationId}/messages`, { params: { page } }).then(r => r.data),

  sendMessage: (conversationId: number, content: string): Promise<ChatMessage> =>
    axiosInstance.post(`${BASE}/conversations/${conversationId}/messages`, { content }).then(r => r.data),

  sendFile: (conversationId: number, file: File, caption?: string): Promise<ChatMessage> => {
    const formData = new FormData();
    formData.append('file', file);
    if (caption) formData.append('caption', caption);
    return axiosInstance.post(
      `${BASE}/conversations/${conversationId}/messages/upload`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    ).then(r => r.data);
  },

  deleteMessage: (messageId: number, conversationId: number): Promise<void> =>
    axiosInstance.delete(`${BASE}/messages/${messageId}`, { params: { conversationId } }).then(() => {}),

  markAsRead: (conversationId: number): Promise<void> =>
    axiosInstance.put(`${BASE}/conversations/${conversationId}/read`).then(() => {}),

  getUnreadCount: (): Promise<number> =>
    axiosInstance.get(`${BASE}/unread-count`).then(r => r.data),

  getUsers: (search?: string): Promise<UserSummary[]> =>
    axiosInstance.get(`${BASE}/users`, { params: search ? { search } : undefined }).then(r => r.data),

  addMember: (conversationId: number, userId: number): Promise<void> =>
    axiosInstance.post(`${BASE}/conversations/${conversationId}/members`, { userId }).then(() => {}),

  removeMember: (conversationId: number, userId: number): Promise<void> =>
    axiosInstance.delete(`${BASE}/conversations/${conversationId}/members/${userId}`).then(() => {}),

  delegateAdmin: (conversationId: number, userId: number): Promise<void> =>
    axiosInstance.put(`${BASE}/conversations/${conversationId}/members/${userId}/delegate-admin`).then(() => {}),

  revokeAdmin: (conversationId: number, userId: number): Promise<void> =>
    axiosInstance.put(`${BASE}/conversations/${conversationId}/members/${userId}/revoke-admin`).then(() => {}),

  leaveGroup: (conversationId: number): Promise<void> =>
    axiosInstance.post(`${BASE}/conversations/${conversationId}/leave`).then(() => {}),

  deleteGroup: (conversationId: number): Promise<void> =>
    axiosInstance.delete(`${BASE}/conversations/${conversationId}`).then(() => {}),
};

export default chatService;
